export default "__VITE_ASSET__DOAbNDiD__"